export const PLAY_VIDEO = 'PLAY_VIDEO';

export function onPlayVideo(exerciseId) {
    return {
        type: PLAY_VIDEO,
        payload: {
            exerciseId,
        },
    };
}
